import { useState } from 'react';

export default function Navbar({ url, setUrl, onLogout, panelName }) {
  const [inputVal, setInputVal] = useState(url);

  const handleSubmit = (e) => {
    e.preventDefault();
    let val = inputVal.trim();
    if (val && !val.startsWith('http')) val = 'https://' + val;
    setUrl(val);
  };

  return (
    <div style={{
      background: 'var(--bg-surface)',
      borderBottom: '1px solid var(--border)',
      padding: '12px 24px',
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      flexWrap: 'wrap',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    }}>
      {/* Logo */}
      <div style={{
        fontFamily: 'var(--font-display)',
        fontSize: '20px',
        fontWeight: '800',
        letterSpacing: '-0.5px',
        color: 'var(--text-1)',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}>
        {panelName || 'GEO'}<span style={{ color: 'var(--accent)' }}>-SEO</span>
        <span style={{ fontSize: '10px', fontWeight: '400', color: 'var(--text-3)', marginLeft: '8px', fontFamily: 'var(--font-mono)', letterSpacing: '1px' }}>CONTROL</span>
      </div>

      {/* URL Input */}
      <form onSubmit={handleSubmit} style={{ flex: 1, display: 'flex', gap: '8px', minWidth: '200px' }}>
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          borderRadius: '8px',
          padding: '0 12px',
          gap: '8px',
        }}>
          <span style={{ fontSize: '12px', color: 'var(--text-3)', fontFamily: 'var(--font-mono)', flexShrink: 0 }}>URL</span>
          <input
            type="text"
            value={inputVal}
            onChange={e => setInputVal(e.target.value)}
            placeholder="https://example.com"
            style={{
              flex: 1,
              background: 'none',
              border: 'none',
              outline: 'none',
              color: 'var(--text-1)',
              fontSize: '13px',
              fontFamily: 'var(--font-mono)',
              padding: '9px 0',
            }}
          />
        </div>
        <button type="submit" style={{
          padding: '9px 18px',
          background: 'var(--accent)',
          border: 'none',
          borderRadius: '8px',
          color: '#0a0a0f',
          fontSize: '12px',
          fontWeight: '700',
          fontFamily: 'var(--font-display)',
          cursor: 'pointer',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}>
          SET URL
        </button>
      </form>

      {/* Live indicator + logout */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <div style={{
            width: '6px', height: '6px', borderRadius: '50%',
            background: 'var(--good)',
            animation: 'pulse 2s ease infinite',
          }} />
          <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}`}</style>
          <span style={{ fontSize: '11px', color: 'var(--text-3)', fontFamily: 'var(--font-mono)' }}>authenticated</span>
        </div>
        <button
          onClick={onLogout}
          style={{
            padding: '7px 14px',
            background: 'none',
            border: '1px solid var(--border)',
            borderRadius: '6px',
            color: 'var(--text-3)',
            fontSize: '12px',
            fontFamily: 'var(--font-mono)',
            cursor: 'pointer',
            transition: 'all 0.15s',
          }}
          onMouseEnter={e => { e.target.style.borderColor = 'var(--poor)'; e.target.style.color = 'var(--poor)'; }}
          onMouseLeave={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.color = 'var(--text-3)'; }}
        >
          logout
        </button>
      </div>
    </div>
  );
}
